import { borderRadius, SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const Currency = styled.span`
  font-size: 8px;
  text-transform: uppercase;
  margin-top: 2px;
`;

export const StampWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const FlexWrapper = styled.div`
  display: flex;
  gap: 2px;
  justify-content: end;
`;

export const PriceWrapper = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  justify-content: flex-end;
  flex-basis: 40%;
  gap: 4px;

  color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--text-disabled)' : 'var(--text-default)'};
`;

export const CircleStamp = styled.div<{
  $color: string;
}>`
  width: 6px;
  height: 6px;
  ${borderRadius.rFull}
  background-color: ${({ $color }) => $color};
`;

export const SquareStamp = styled.div<{
  $color: string;
}>`
  width: 6px;
  height: 6px;
  background-color: ${({ $color }) => $color};
`;

export const StyledSkeletonLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '40px',
        height: '20px',
        borderRadius: '8px',
      },
    },
  ],
})`
  display: flex;
  justify-content: flex-end;
`;
